import React from 'react';
import PropTypes from 'prop-types';
import { first, remove } from 'lodash';
import { CprTooltip } from 'canopy-styleguide!sofe';
import {hasAccess} from 'cp-client-auth!sofe'
import TeamMemberDropDown from './team-member-drop-down/drop-down.component.js';
import { css, StyleSheet } from 'aphrodite';

export default class Participants extends React.Component {
  state = {
    dropDown: false,
  };

  goToParticipantsIndex(contactId) {
    window.location = '/#/client/' + contactId + '/participants';
  }

  slimUsersList() {
    let slimUsersList = [];
    const usersList = this.props.users.filter(tm => tm.role !== 'Client');

    if (usersList.length > 6) {
      const currentUser = first(remove(usersList, user => this.props.loggedInUser.id === user.id));

      const extraLength = usersList.length - 5;
      const extraUsers = remove(usersList, (user, index) => index < extraLength);
      slimUsersList = [
        { id: -1, name: extraUsers.map(user => user.name).join(', '), initials: `+${extraLength}` },
        ...(currentUser ? [currentUser] : []),
        ...usersList,
      ];
    } else {
      slimUsersList = usersList;
    }

    return slimUsersList;
  }

  render() {
    const canAdd = hasAccess(this.props.loggedInUser)('contacts_assign_team_members')
    return (
      <ul className="cps-topnav-secondary__content__right-menu +tall" style={{ whiteSpace: 'nowrap', display: 'flex' }}>
        {this.props.users &&
          this.slimUsersList().map((user, i) => {
            return (
              <CprTooltip html={user.name} key={user.id}>
                <li key={i} className="cps-margin-right-4">
                  <div
                    className={`${css(styles.dropDownSquare)} cps-label-square +medium ${
                      this.props.loggedInUser.id === user.id ? '+active' : ''
                    }`}>
                    <div className="cps-center-vertical">{user.initials}</div>
                  </div>
                </li>
              </CprTooltip>
            );
          })}

        {canAdd && <li
          onClick={() => {
            this.setState({
              dropDown: true,
            });
          }}>
          <div
            style={{ position: 'relative' }}
            className={`${css(styles.dropDownSquare)} cps-label-square +medium +active`}>
            <div className="cps-center-vertical">
              <i className="cps-icon cps-icon-add-person cps-white" />
            </div>
            {this.state.dropDown && (
              <TeamMemberDropDown
                hasAccess={this.props.hasAccess}
                contactId={this.props.contactId}
                closeDropDown={() => {
                  this.setState({
                    dropDown: false,
                  });
                }}
                teamMembers={this.props.users.filter(user => user.role === 'TeamMember')}
              />
            )}
          </div>
        </li>}
      </ul>
    );
  }
}

Participants.propTypes = {
  contactId: PropTypes.number,
  users: PropTypes.array,
};

const styles = StyleSheet.create({
  dropDownSquare: {
    cursor: 'pointer',
    ':hover': {
      opacity: '1',
    },
  },
});
